import { _getImageWidth } from './_getImageWidth';
import { _originDtImageUrl } from './_originDtImageUrl';

/**
 * @description 裁剪缩放图片
 * @param originUrl 图片地址
 * @param t 统一传true
 * @param w 期望宽度
 * @param isSquare 是否裁剪成居中方图
 * @returns
 */
export const _dtImageTrans = (
  originUrl: string,
  t?: boolean,
  w?: number,
  isSquare?: boolean,
): string => {
  if (!originUrl) {
    return originUrl;
  }
  let url = originUrl.trim();
  let hostname = '';
  let pathname = '';
  try {
    const urlObj = new URL(url);
    hostname = urlObj.hostname;
    pathname = urlObj.pathname;
  } catch {
    hostname = '';
    pathname = url;
  }

  const isHttps = (url: string): boolean => url.startsWith('https');
  const isQiniu = (url: string): boolean => url.startsWith('http://dt-img.qiniudn.com');
  const isDuitang = (hostname: string): boolean =>
    hostname.endsWith('duitang.com') || hostname.endsWith('dtstatic.com');

  // 七牛只有http 没有 https
  // 七牛缩略只支持固定宽度，高度自适应
  if (isQiniu(url)) {
    return _originDtImageUrl(url) + '?imageView2/2/w/' + _getImageWidth(w);
  }

  if (!isDuitang(hostname)) {
    console.log('非堆糖域名图片', url);
    return url;
  }

  if (!isHttps(url)) {
    console.log('非https图片请求，请修改:' + url);
  }

  if (t) {
    const host = 'https://c-ssl.dtstatic.com';
    url = host + pathname;
    const imgWidth = _getImageWidth(w);

    // 不符合宽度高度范围，还是原尺寸
    // h为0时，url不带'_c'
    // c = c && h !== 0 ? "_" + c : "";
    const c = isSquare ? '_c' : '';
    const imgHeight = isSquare ? imgWidth : 0;
    return _dtImageTrans(url).replace(
      /(\.[a-z_]+)$/gi,
      '.thumb.' + imgWidth + '_' + imgHeight + c + '$1',
    );
  } else {
    const originImageUrl = _originDtImageUrl(url);
    return originImageUrl;
  }
};
